import { loginStore } from "@/modules/login/store";
import { getPromptDetail } from "@/pages/Gallery/api";
import { GalleryItemType, ImgAndPromptItemType } from "@/stores/gallery";
import { AIMetaType } from "@/types/meta";
import { Actions } from "@/utils/api";
import { genBlock } from "@/utils/bem";
import { Editor_Gallery_Words } from "@/utils/lang/editor";
import { useOwnToast } from "@/utils/misc";
import { postOperation } from "@/utils/statistics/operation";
import { Box, Button, useBoolean } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { usePrevious } from "ahooks";
import { observer } from "mobx-react-lite";
import React, { Dispatch, SetStateAction, useMemo } from "react";
// import styles from "./index.module.scss";
import "./style.scss";

interface GalleryItemProps {
  setCurrent: Dispatch<SetStateAction<number>>;
  data: any;
  setDetailVisible: Dispatch<SetStateAction<boolean>>;
  list: GalleryItemType[];
  onSrcChange?: () => void;
  keyword?: string;
}
const itemBlock = genBlock("e-gallery-item");
const GalleryItem: React.FC<GalleryItemProps> = ({
  setCurrent,
  data,
  setDetailVisible,
  onSrcChange,
  keyword,
}) => {
  const toastFn = useOwnToast();
  const lang = langStore.tgt;
  const prevSrc = usePrevious(data.photo.src);
  const [loading, loadingOp] = useBoolean(false);

  function handleCheckDetail(e: React.MouseEvent<any, MouseEvent>) {
    e.stopPropagation();
    if (loginStore.isGuest) return;
    setCurrent(Number(data.photo.key));
    setDetailVisible(true);
  }

  const src = useMemo(() => {
    return `${data.photo.src}?x-oss-process=image/resize,w_150&keyword=${keyword}`;
  }, [keyword, data.photo.src]);

  function handleLoaded() {
    if (prevSrc) {
      onSrcChange?.();
    }
  }

  function generateSimilar(e: React.MouseEvent<any, MouseEvent>) {
    e.stopPropagation();
    loadingOp.on();
    getPromptDetail({ image_id: Number(data.photo.key) })
      .then((res) => res)
      .then((res) => {
        if (res.data?.list) {
          const { list } = res.data;
          const item: ImgAndPromptItemType = list?.find(
            (item: ImgAndPromptItemType) => item.image_id.toString() === data.photo.key,
          );
          const meta: AIMetaType = JSON.parse(item.meta_json);
          if (!meta.data.sampler && meta.data.num_steps === 50) {
            meta.data.sampler = "solver";
            meta.data.num_steps = 25;
          }
          postOperation("generate_variation", {
            origin_img: item,
          });
          loadingOp.off();
          Actions.sdVariation({
            t: toastFn,
            lang,
            meta,
            busyAliases: ["generate_same_design"],
            fidelity: 0.8,
          });
        }
      })
      .catch((err) => {
        loadingOp.off();
        console.error(err, "生成同款出错");
      });
  }
  return (
    <Box
      className={itemBlock()}
      onClick={(e) => handleCheckDetail}
      w={data?.photo?.width}
      h={data?.photo?.height}
      left={data.left}
      key={data?.photo?.key}
      top={data.top}
    >
      <img
        className={itemBlock({ e: "preview" })}
        src={src}
        alt=""
        onLoad={handleLoaded}
        onError={handleLoaded}
      />
      <Box
        className={itemBlock({ e: "actions" })}
        w={data?.photo?.width}
        h={data?.photo?.height}
        onClick={handleCheckDetail}
      >
        {loginStore.isGuest ? null : (
          <Button
            variant="outline"
            color="brand.primary"
            borderColor="brand.primary"
            mb="6px"
            size="sm"
            rounded="full"
            w="94px"
            h="24px"
            px="1px"
          >
            {translate(Editor_Gallery_Words["check-detail"], lang)}
          </Button>
        )}
        <Button
          variant="outline"
          color="brand.primary"
          borderColor="brand.primary"
          size="sm"
          rounded="full"
          w="94px"
          h="24px"
          px="1px"
          isLoading={loading}
          loadingText={translate(Editor_Gallery_Words["generete-same"], lang)}
          onClick={generateSimilar}
        >
          {translate(Editor_Gallery_Words["generete-same"], lang)}
        </Button>
      </Box>
    </Box>
  );
};

export default observer(GalleryItem);
